export default "__VITE_ASSET__D94sVsSq__"